/**
 * PeopleGraph — Shared Constants
 */

export const CATEGORIES = [
  { id: "work", label: "Work", color: "#4A7C6F", icon: "💼" },
  { id: "family", label: "Family", color: "#C2785C", icon: "🏠" },
  { id: "social", label: "Social", color: "#7B68AE", icon: "🎉" },
  { id: "neighbors", label: "Neighbors", color: "#5B8FA8", icon: "🏘️" },
  { id: "community", label: "Community", color: "#B8945A", icon: "🤝" },
  { id: "other", label: "Other", color: "#8B8B8B", icon: "📌" },
];

export const CATEGORY_MAP = Object.fromEntries(
  CATEGORIES.map((c) => [c.id, c]),
);
